<template>
  <el-dialog
    title="验货"
    :visible.sync="visible"
    :before-close="inSpectionStateClose"
    width="1700px"
    :close-on-click-modal="false"
  >
    <!-- table表格 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="goods.title" label="商品名称" :key="1" />
      <el-table-column prop="goods.brand" label="品牌" :key="2" />
      <el-table-column prop="goods.sku_value" label="规格" :key="3" />
      <el-table-column prop="goods.unit" label="单位" :key="4" width="80" />
      <el-table-column
        prop="goods_count"
        label="采购数量"
        :key="5"
        align="center"
      />
      <el-table-column label="实收数量" :key="6" align="center">
        <template slot-scope="scope" v-if="scope.row.validation_data">
          <el-input-number
            v-model="scope.row.validation_data.paid_count"
            controls-position="right"
            :min="0"
            size="small"
            style="width: 100px"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="赠品数量" :key="7" align="center">
        <template slot-scope="scope" v-if="scope.row.validation_data">
          <el-input-number
            v-model="scope.row.validation_data.giving_count"
            controls-position="right"
            :min="0"
            size="small"
            style="width: 100px"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="总成本价" :key="8" align="center">
        <template slot-scope="scope" v-if="scope.row.validation_data">
          <el-input-number
            v-model="scope.row.validation_data.cost_price"
            controls-position="right"
            :min="0"
            size="small"
            style="width: 100px"
          ></el-input-number>
        </template>
      </el-table-column>
      <!--  :picker-options="pickerOptions" -->
      <el-table-column label="生产日期" :key="9" align="center" width="150">
        <template slot-scope="scope" v-if="scope.row.validation_data">
          <el-date-picker
            v-model="scope.row.productTime"
            type="date"
            placeholder="选择日期"
            style="width: 130px"
            size="small"
            v-if="!splitDate"
            :picker-options="pickerOptionsL"
            @change="changeDate"
          ></el-date-picker>
          <span v-else>- -</span>
        </template>
      </el-table-column>
      <el-table-column label="保质期(月)" :key="12" align="center">
        <template slot-scope="scope" v-if="scope.row.validation_data">
          <el-input-number
            v-if="!splitDate"
            v-model="scope.row.month"
            size="small"
            :min="0"
            controls-position="right"
            style="width: 100px"
            @change="changeMonth"
          ></el-input-number>
          <span v-else>- -</span>
        </template>
      </el-table-column>
      <el-table-column label="到期日期" :key="13" align="center" width="150">
        <template slot-scope="scope" v-if="scope.row.validation_data">
          <el-date-picker
            v-model="scope.row.date"
            type="date"
            placeholder="选择日期"
            style="width: 130px"
            size="small"
            v-if="!splitDate"
            value-format="timestamp"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <span v-else>- -</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goods.times"
        label="使用次数"
        :key="10"
        align="center"
      >
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.goods.times"
            controls-position="right"
            :min="1"
            size="small"
            style="width: 100px"
            v-if="!splitDate"
            :disabled="scope.row.goods.goods_type == '0' ? true : false"
          ></el-input-number>
          <span v-else>- -</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" :key="11" align="center">
        <template slot-scope="scope">
          <el-button
            @click="handleSplitClick(scope.row)"
            type="text"
            size="small"
            >拆效期</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 异常状态 -->
    <div class="comH">异常状态</div>
    <div class="abnormal">
      <div class="abnormalView">
        <div class="abnormalViewName">漏发数量:</div>
        <el-input-number
          v-model="tableData[0].validation_data.abnormal_info.leakage_count"
          controls-position="right"
          :min="0"
          size="small"
          style="width: 100px"
        ></el-input-number>
      </div>
      <div class="abnormalView" v-if="tableData[0].validation_data">
        <div class="abnormalViewName">破损数量:</div>
        <el-input-number
          v-model="tableData[0].validation_data.abnormal_info.broken_count"
          controls-position="right"
          :min="0"
          size="small"
          style="width: 100px"
        ></el-input-number>
      </div>
      <div class="abnormalView" v-if="tableData[0].validation_data">
        <div class="abnormalViewName">过期数量:</div>
        <el-input-number
          v-model="tableData[0].validation_data.abnormal_info.overdue_count"
          controls-position="right"
          :min="0"
          size="small"
          style="width: 100px"
        ></el-input-number>
      </div>
      <div class="abnormalView" v-if="tableData[0].validation_data">
        <div class="abnormalViewName">调换数量:</div>
        <el-input-number
          v-model="tableData[0].validation_data.abnormal_info.switch_count"
          controls-position="right"
          :min="0"
          size="small"
          style="width: 100px"
        ></el-input-number>
      </div>
      <div class="abnormalView" v-if="tableData[0].validation_data">
        <div class="abnormalViewName">无货数量:</div>
        <el-input-number
          v-model="tableData[0].validation_data.abnormal_info.no_count"
          controls-position="right"
          :min="0"
          size="small"
          style="width: 100px"
        ></el-input-number>
      </div>
    </div>
    <!-- 创建有效期 -->
    <div class="dateView" v-for="(item, index) in dateArr" :key="index">
      <div class="dateTitle">有效期{{ index + 1 }}:</div>
      <div class="dateItem">
        <div class="dateItemName">生产日期:</div>
        <el-date-picker
          v-model="item.overdue_time"
          type="date"
          placeholder="选择日期"
          style="width: 130px"
          size="small"
          :picker-options="pickerOptionsL"
          @change="changeDateT(index)"
        ></el-date-picker>
      </div>
      <div class="dateItem">
        <div class="dateItemName">保质期(月):</div>
        <el-input-number
          v-model="item.month"
          controls-position="right"
          :min="0"
          size="small"
          style="width: 100px"
          @change="changeMonthT(index)"
        ></el-input-number>
      </div>
      <div class="dateItem">
        <div class="dateItemName">到期日期:</div>
        <el-date-picker
          v-model="item.overtime"
          value-format="timestamp"
          type="date"
          placeholder="选择日期"
          style="width: 130px"
          :picker-options="pickerOptions"
          size="small"
        ></el-date-picker>
      </div>
      <div class="dateItem">
        <div class="dateItemName">数量:</div>
        <el-input-number
          v-model="item.count"
          controls-position="right"
          :min="0"
          size="small"
          style="width: 100px"
        ></el-input-number>
      </div>
      <div class="dateItem">
        <div class="dateItemName">使用次数:</div>
        <el-input-number
          v-model="item.times"
          controls-position="right"
          :min="0"
          size="small"
          style="width: 100px"
          :disabled="inspectionData.goods.goods_type == '0' ? true : false"
        ></el-input-number>
      </div>
      <el-button size="small" @click="handleDeleteClick(index)">移除</el-button>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmitClick">提 交</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateValidation } from "@/api/purchaseApi.js";
export default {
  props: {
    inSpectionState: {
      //显示状态
      default: false,
    },
    id: {
      //采购单id
      default: "",
    },
    inspectionData: {
      //商品数据
      default: {},
    },
  },
  data() {
    return {
      changeIndex: null,
      visible: true,
      tableData: [], //table数据
      splitDate: false, //拆分有效期状态
      dateArr: [], //有效期数组
      step: 0,
      month: null,
      shengchanriqi: null,
      monthT: null,
      shengchanriqiT: null,
      pickerOptions: {
        disabledDate(time) {
          //如果没有后面的-8.64e7就是不可以选择今天的
          return time.getTime() < Date.now();
        },
      },
      pickerOptionsL: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    console.log(this.inspectionData.validation_data);
    if (this.inspectionData.validation_data.overdue_time_list != undefined) {
      for (
        let i = 0;
        i < this.inspectionData.validation_data.overdue_time_list.length;
        i++
      ) {
        this.inspectionData.validation_data.overdue_time_list[i].overdue_time =
          new Date(
            this.inspectionData.validation_data.overdue_time_list[i]
              .overdue_time * 1000
          );
      }
      if (this.inspectionData.validation_data.overdue_time_list.length > 1) {
        this.splitDate = true;
        this.dateArr = this.inspectionData.validation_data.overdue_time_list;
      } else if (
        this.inspectionData.validation_data.overdue_time_list.length == 1
      ) {
        this.inspectionData.date =
          this.inspectionData.validation_data.overdue_time_list[0].overdue_time.getTime();
        console.log(this.inspectionData.date);
      }
    }
    this.tableData = [this.inspectionData];
    console.log("table", this.tableData);
  },
  watch: {
    // 监视状态发生改变
    inSpectionState() {
      this.visible = this.inSpectionState;
    },
  },
  methods: {
    // 拆分日期
    changeMonthT(index) {
      console.log(index, "下标");
      this.changeIndex = index;
      let tableObj = this.dateArr[index];
      this.monthT = tableObj.month; //保质期(月)
      this.getOverTimeT();
    },
    changeDateT(index) {
      this.changeIndex = index;
      console.log(index, "下标");
      let tableObj = this.dateArr[index];
      this.shengchanriqiT =
        tableObj.overdue_time == undefined
          ? ""
          : this.formatDateTime(tableObj.overdue_time).toString(); //生产日期
      console.log(this.shengchanriqiT);
      this.getOverTimeT();
    },
    // 计算到期时间
    getOverTimeT() {
      if (
        this.dateArr[this.changeIndex].month &&
        this.dateArr[this.changeIndex].overdue_time
      ) {
        console.log(this.month, "月");
        let daoqi =
          parseInt(this.dateArr[this.changeIndex].month * 60 * 60 * 24 * 30) +
          parseInt(
            this.formatDateTime(
              this.dateArr[this.changeIndex].overdue_time
            ).toString()
          );

        this.dateArr[this.changeIndex].overtime = daoqi + "000";
      }
    },
    changeMonth() {
      let tableObj = this.tableData[0];
      this.month = tableObj.month; //保质期(月)
      this.getOverTime();
    },
    changeDate() {
      let tableObj = this.tableData[0];
      this.shengchanriqi =
        tableObj.productTime == undefined
          ? ""
          : this.formatDateTime(tableObj.productTime).toString(); //生产日期
      console.log(this.shengchanriqi);
      this.getOverTime();
    },
    // 计算到期时间
    getOverTime() {
      if (this.month && this.shengchanriqi) {
        console.log(this.month, "月");
        let daoqi =
          parseInt(this.month * 60 * 60 * 24 * 30) +
          parseInt(this.shengchanriqi);
        let tableObj = this.tableData[0];
        tableObj.date = daoqi + "000";
        console.log(daoqi, "到期");
      }
    },
    // 月转化秒
    getChangeTime(n) {
      return 60 * 60 * 24 * 30 * n;
    },
    //提交
    handleSubmitClick() {
      var timestamp =
        Date.parse(new Date()) / 1000 + parseInt(60 * 60 * 24 * 30 * 9);
      console.log(this.tableData[0], "123");
      let tableObj = this.tableData[0];
      let actualNum = tableObj.validation_data.paid_count; //实收数量
      let giveNum = tableObj.validation_data.giving_count; //赠品数量
      let costPrice = tableObj.validation_data.cost_price; //成本价
      let youxiaoqi = tableObj.date == undefined ? "" : tableObj.date / 1000; //有效期
      let dateArr = this.dateArr; //有效期数组
      let times = tableObj.goods.times; //使用次数
      console.log(youxiaoqi, "国企");

      //实收+异常  ===采购
      let yichangNum =
        this.loufaNum + this.posunNum + this.guoqiNum + this.diaohuanNum;

      // if(actualNum == 0 && giveNum == 0){
      // 	this.$message({
      // 		type:'warning',
      // 		message:'请填写实收数量或者赠品数量'
      // 	})
      // 	return
      // }

      if (actualNum > 0 && costPrice == 0) {
        this.$message({
          type: "warning",
          message: "已填写实收数量，成本价必须填写",
        });
        return;
      }

      //多效期状态   数量循环+ ==实收+赠品
      if (this.splitDate) {
        let step = 0;
        for (let i = 0; i < dateArr.length; i++) {
          step += dateArr[i].count;
          if (dateArr[i].overtime == "") {
            this.$message({
              type: "warning",
              message: "多效期时，请添加到期日期",
            });
            return;
          }
          dateArr[i].overdue_time = dateArr[i].overtime / 1000;
        }
        console.log(step);
        if (step == 0) {
          this.$message({
            type: "warning",
            message: "多效期时，请添加数量",
          });
          return;
        }
        if (step != actualNum + giveNum) {
          this.$message({
            type: "warning",
            message: "多效期数量相加必须等于实收数量加赠品数量",
          });
          return;
        }
      } else {
        if (youxiaoqi == "") {
          this.$message({
            type: "warning",
            message: "请填写到期日期",
          });
          return;
        }
        if (times == 0) {
          this.$message({
            type: "warning",
            message: "请正确填写使用次数",
          });
          return;
        }
      }

      if (
        yichangNum + actualNum > tableObj.goods_count &&
        tableObj.goods_count != 0
      ) {
        this.$message({
          type: "warning",
          message: "实收数量加异常数量不能大于采购数量",
        });
        return;
      }
      if (
        yichangNum + actualNum < tableObj.goods_count &&
        tableObj.goods_count != 0
      ) {
        this.$message({
          type: "warning",
          message: "实收数量加异常数量不能小于采购数量",
        });
        return;
      }
      console.log(actualNum, giveNum, costPrice, youxiaoqi, times);
      console.log(this.dateArr, tableObj);
      // if (this.dateArr.length > 0) {
      //   let arr = [];
      //   for (let i = 0; i < dateArr.length; i++) {
      //     arr.push(dateArr[i].overtime);
      //     let a = arr.every((item) => {
      //        item > timestamp;
      //     });
      //     console.log(a,'a');
      //   }
      // }
      if (youxiaoqi) {
        if (timestamp > youxiaoqi) {
          this.$confirm("存在临期商品, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              console.log(111);
              let parmars = {
                id: this.id, //采购单id
                procure_goods_id: tableObj.procure_goods_id, //采购商品id
                validation_data: {
                  paid_count: actualNum, //实收数量
                  giving_count: giveNum, //赠送数量
                  abnormal_info: {
                    leakage_count:
                      tableObj.validation_data.abnormal_info.leakage_count, //漏发数量
                    overdue_count:
                      tableObj.validation_data.abnormal_info.overdue_count, //过期数量
                    broken_count:
                      tableObj.validation_data.abnormal_info.broken_count, //破损数量
                    switch_count:
                      tableObj.validation_data.abnormal_info.switch_count, //调换数量
                    no_count: tableObj.validation_data.abnormal_info.no_count, //无货数量
                  },
                  cost_price: costPrice,
                  remarks: tableObj.validation_data.remarks,
                  overdue_time_list: dateArr,
                },
              };
              if (this.splitDate) {
                parmars.overdue_time_list = dateArr;
              } else {
                let dates = [];
                let dateObj = {
                  overdue_time: parseInt(youxiaoqi),
                  count: giveNum + actualNum,
                  times: times,
                };
                dates.push(dateObj);
                parmars.validation_data.overdue_time_list = dates;
              }
              console.log(parmars);
              updateValidation(parmars).then((res) => {
                if (res.code == 0) {
                  console.log(res);
                  this.$message({
                    type: "success",
                    message: "已验货",
                  });
                  this.$emit("refresh", false);
                  // this.visible = false;
                }
              });
            })
            .catch(() => {
              this.$emit("refresh", false);
            });
        }
      }
      let parmars = {
        id: this.id, //采购单id
        procure_goods_id: tableObj.procure_goods_id, //采购商品id
        validation_data: {
          paid_count: actualNum, //实收数量
          giving_count: giveNum, //赠送数量
          abnormal_info: {
            leakage_count: tableObj.validation_data.abnormal_info.leakage_count, //漏发数量
            overdue_count: tableObj.validation_data.abnormal_info.overdue_count, //过期数量
            broken_count: tableObj.validation_data.abnormal_info.broken_count, //破损数量
            switch_count: tableObj.validation_data.abnormal_info.switch_count, //调换数量
            no_count: tableObj.validation_data.abnormal_info.no_count, //无货数量
          },
          cost_price: costPrice,
          remarks: tableObj.validation_data.remarks,
          overdue_time_list: dateArr,
        },
      };
      if (this.splitDate) {
        parmars.overdue_time_list = dateArr;
      } else {
        let dates = [];
        let dateObj = {
          overdue_time: parseInt(youxiaoqi),
          count: giveNum + actualNum,
          times: times,
        };
        dates.push(dateObj);
        parmars.validation_data.overdue_time_list = dates;
      }
      console.log(parmars);
      updateValidation(parmars).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.$message({
            type: "success",
            message: "已验货",
          });
          this.$emit("refresh", false);
          // this.visible = false;
        }
      });
    },
    //转时间戳
    formatDateTime(timeStr) {
      let time = new Date(timeStr);
      let datetime = time.getTime() / 1000;
      return datetime;
    },
    //关闭弹框
    inSpectionStateClose(done) {
      done();
      this.$emit("closeOn", false);
    },
    //移除有效期
    handleDeleteClick(index) {
      console.log(index);
      this.dateArr.splice(index, 1);
      if (this.dateArr.length == 0) {
        this.splitDate = false;
      }
    },
    //拆有效期
    handleSplitClick() {
      this.splitDate = true;
      let tableObj = this.tableData[0];
      tableObj.date = "";
      tableObj.productTime = "";
      tableObj.month = "";
      if (this.splitDate) {
        let obj = {
          overdue_time: "",
          month: 0,
          count: 0,
          overtime: "",
          times: this.tableData[0].goods.times,
        };
        this.dateArr.push(obj);
      }
      console.log(this.dateArr);
    },
  },
};
</script>
<style lang="scss" scoped>
.comH {
  font-size: 16px;
  color: #000;
  margin: 20px 0;
}

.abnormal {
  display: flex;
  align-items: center;

  .abnormalView {
    display: flex;
    align-items: center;
    margin-right: 60px;

    .abnormalViewName {
      font-size: 14px;
      color: #000;
      margin-right: 10px;
    }
  }
}

.dateView {
  display: flex;
  margin: 20px 0;
  align-items: center;
  font-size: 16px;

  .dateTitle {
    color: #000;
    margin-right: 20px;
  }

  .dateItem {
    display: flex;
    align-items: center;
    margin-right: 20px;

    .dateItemName {
      margin-right: 10px;
    }
  }
}
</style>
